import {AsyncPage, Empty} from 'Core/models/Async';
import {DateRange, EmptyDateRange} from 'Core/models/DateRange';
import {FilterOptionUnion, FilterOptionValue} from 'Core/models/FilterOption';
import {Page} from 'Core/models/Page';
import {Sort} from 'Shared/components/PagedView/Table/Sort';
import {createAction} from 'Shared/utilities/actionCreator';
import {Option, fromNullable, none} from 'fp-ts/lib/Option';

export interface DocumentUploadDto {
  policyNumber: string;
  accountNumber?: string | null;
  fileName: string;
  dateOfUpload: Date;
  uploadStatus: string;
}

export enum DocumentUploadActionTypes {
  FETCH_DOCUMENTS = 'documents/FETCH_DOCUMENTS',
  CHANGE_DOCUMENTS = 'documents/CHANGE_DOCUMENTS',
  CHANGE_SORT = 'documents/CHANGE_SORT',
  CLEAR_SORT = 'documents/CLEAR_SORT',
  RESET_DOCUMENTS = 'documents/RESET_DOCUMENTS',
  CHANGE_DOCUMENT_FILTER = 'documents/CHANGE_DOCUMENT_FILTER',
}

export type DocumentFilter = {
  policyNumber: string;
  accountNumber: string;
  fileName: string;
  uploadStatus: FilterOptionUnion;
  dateOfUpload: DateRange;
};

export const fetchDocuments = (pageOption?: Page<DocumentUploadDto>, filter?: DocumentFilter, sort?: Sort) =>
  createAction(DocumentUploadActionTypes.FETCH_DOCUMENTS, {pageOption, filter, sort});

export const changeDocuments = (documents: AsyncPage<Page<DocumentUploadDto>>) =>
  createAction(DocumentUploadActionTypes.CHANGE_DOCUMENTS, documents);

export const changeSort = (sort?: Sort) => createAction(DocumentUploadActionTypes.CHANGE_SORT, {sort});

export const clearSort = () => createAction(DocumentUploadActionTypes.CLEAR_SORT);

export const changeDocumentFilter = (documentFilter: DocumentFilter) =>
  createAction(DocumentUploadActionTypes.CHANGE_DOCUMENT_FILTER, documentFilter);

type DocumentUploadState = {
  documents: AsyncPage<Page<DocumentUploadDto>>;
  sort: Option<Sort>;
  filter: DocumentFilter;
  pageOption: Option<Page<DocumentUploadDto>>;
};

const EMPTY_DOCUMENTS_FILTER = {
  policyNumber: '',
  accountNumber: '',
  fileName: '',
  uploadStatus: FilterOptionValue.EmptyOption(),
  dateOfUpload: EmptyDateRange,
};

const DEFAULT_STATE: DocumentUploadState = {
  documents: new Empty(),
  sort: none,
  filter: EMPTY_DOCUMENTS_FILTER,
  pageOption: none,
};

export default function documentUploadReducer(
  state: DocumentUploadState = DEFAULT_STATE,
  action: any
): DocumentUploadState {
  switch (action.type) {
    case DocumentUploadActionTypes.CHANGE_DOCUMENTS:
      return {...state, documents: action.payload};
    case DocumentUploadActionTypes.CHANGE_SORT:
      return {...state, sort: fromNullable(action.payload.sort)};
    case DocumentUploadActionTypes.CLEAR_SORT:
      return {...state, sort: DEFAULT_STATE.sort};
    case DocumentUploadActionTypes.CHANGE_DOCUMENT_FILTER:
      return {...state, filter: {...state.filter, ...action.payload}};
    default:
      return state;
  }
}

export const DocumentStatus: {name: string; value: string}[] = [
  {
    name: 'Not Received',
    value: 'content-failed',
  },
  {
    name: 'Quarantined',
    value: 'content-create-quarantined',
  },
  {
    name: 'Submitted',
    value: 'submitted',
  },
  {
    name: 'Successful',
    value: 'Successful',
  },
];
